import PiggyvestLogo from '../../assets/images/piggyvest-white.svg';
import HidePasswordIcon from '../../assets/icons/hide-password-icon.svg';
import ShowPasswordIcon from '../../assets/icons/show-password-icon.svg';
import { Button } from '@piggytechng/component-library';
import './Login.scss';
import { useEffect, useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { OverideButtonStyle } from '../../helpers/utils';
import OtpInput from '../../components/Otp/input';
import GridBackground from '../../components/GridBackground/GridBackground';

const Login = () => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const {
    handleLoginForm,
    handleOtpForm,
    loginForm,
    otpForm,
    login,
    activeScreen,
    qrCodeImg,
    isLoading,
    request2FaResetPin,
    verify2FaResetPin,
  } = useAuth();

  useEffect(() => {
    if (otpForm.otp && otpForm.otp.length === 6) {
      if (activeScreen === '2fa-reset-verification') {
        verify2FaResetPin({ preventDefault: () => {} });
      } else {
        login({ preventDefault: () => {} });
      }
    }
  }, [otpForm.otp]);

  return (
    <GridBackground shootingStarCount={5}>
      <div className="login">
        <div className="piggyvest-logo">
          <div id="logo-img">
            <img src={PiggyvestLogo} alt="" />
          </div>
        </div>

        <div className="login-section">
          {activeScreen === 'login' && (
            <div className="login-screen">
              <div className="login__container">
                <h1 className="">Welcome</h1>
                <p className="">Please, fill in the details to log in to the Admin Dashboard</p>
                <form onSubmit={() => {}} className="login__container--form">
                  <div className="form-group">
                    <div className="email-input-container">
                      <div className="email-label label">
                        <p>Email address</p>
                      </div>
                      <input onChange={handleLoginForm} value={loginForm.identifier} name="identifier" type="email" />
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="password-input-container">
                      <div className="password-label label">
                        <p>Password</p>
                      </div>
                      <div className="password-input">
                        <input
                          type={`${showPassword ? 'text' : 'password'}`}
                          onChange={handleLoginForm}
                          value={loginForm.password}
                          name="password"
                        />
                        <img
                          src={showPassword ? HidePasswordIcon : ShowPasswordIcon}
                          alt=""
                          onClick={() => setShowPassword(showPassword ? false : true)}
                        />
                      </div>
                    </div>
                  </div>
                  <Button
                    type="submit"
                    {...OverideButtonStyle}
                    style={{
                      fontFamily: 'Jakarta',
                    }}
                    loading={isLoading}
                    disabled={false}
                    onClick={(e) => login(e)}
                  >
                    Log In
                  </Button>
                </form>
              </div>
            </div>
          )}
          {activeScreen === 'otp-input-screen' && (
            <div className="otp-screen">
              <h1 className="otp-screen-header">2Factor Authentication</h1>
              <div className="otp__container">
                <div className="otp-form">
                  <h1>Enter your OTP</h1>
                  <p>Enter the 6-digit confirmation code generated by your Google Authenticator app.</p>
                  <div className="otp-input-container">
                    <form onSubmit={login}>
                      <OtpInput setOtpValue={handleOtpForm} showValues />
                    </form>
                  </div>
                  <Button
                    {...OverideButtonStyle}
                    style={{
                      fontFamily: 'Jakarta',
                      fontSize: '14px',
                    }}
                    type="submit"
                    loading={isLoading}
                    disabled={false}
                    onClick={login}
                  >
                    Submit
                  </Button>
                  <div className="bottom-options">
                    <span className="bottom-options__buttons" onClick={() => window.location.reload()}>
                      Return to login
                    </span>
                    <span
                      className="bottom-options__buttons"
                      onClick={() => request2FaResetPin({ preventDefault: () => {} })}
                    >
                      Reset 2FA
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeScreen === '2fa-setup-screen' && (
            <div className="two-fa-setup">
              <h1>Setup MFA</h1>
              <div className="two-fa-setup-container">
                <p>Please the scan QRCode using an authenticator app to setup your Multi Factor Authentication</p>

                <div className="qrcode-container">
                  <img className="qrcode-image" src={qrCodeImg} alt="" />
                </div>

                <p>Enter the pin generated in your authenticator app</p>
                <form onSubmit={login}>
                  <OtpInput setOtpValue={handleOtpForm} showValues />
                </form>

                <Button
                  {...OverideButtonStyle}
                  style={{
                    fontFamily: 'Jakarta',
                    fontSize: '14px',
                  }}
                  type="submit"
                  loading={isLoading}
                  disabled={false}
                  onClick={login}
                >
                  Verify
                </Button>
              </div>
            </div>
          )}

          {activeScreen === '2fa-reset-verification' && (
            <div className="otp-screen">
              <h1 className="otp-screen-header">Reset 2FA</h1>
              <div className="otp__container">
                <div className="otp-form">
                  <h1>Enter Reset PIN</h1>
                  <p>Enter the 6-digit reset PIN sent to your email.</p>
                  <div className="otp-input-container">
                    <form onSubmit={verify2FaResetPin}>
                      <OtpInput setOtpValue={handleOtpForm} showValues />
                    </form>
                  </div>
                  <Button
                    {...OverideButtonStyle}
                    style={{ fontFamily: 'Jakarta', fontSize: '14px' }}
                    type="submit"
                    loading={isLoading}
                    disabled={otpForm.otp.length !== 6}
                    onClick={verify2FaResetPin}
                  >
                    Verify
                  </Button>
                  <div className="bottom-options">
                    <span className="bottom-options__buttons" onClick={() => window.location.reload()}>
                      Return to login
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </GridBackground>
  );
};

export default Login;
